import { pxToRem } from '@/core/theme';
import { styled } from '@mui/material';

export type HBIconStyleProps = {
  size?: 'XSmall' | 'small' | 'medium' | 'large';
};

export const HBIconRootStyle = styled('i')(({ size }: HBIconStyleProps) => {
  return {
    fontSize:
      size === 'XSmall'
        ? pxToRem(16)
        : size === 'small'
          ? pxToRem(20)
          : size === 'large'
            ? pxToRem(32)
            : pxToRem(24),
    display: 'flex',
    alignItems: 'center',
  };
});
